import Http from '../api/http';

export default class YouHai extends Http {
  // 增加优海账户
  youHai_addYHAccount() {
    return super.post('youhai/addYHAccount', ...arguments);
  }
  youHai_closeYHAccount() {
    return super.post('youhai/closeYHAccount', ...arguments);
  }
  // 同步组织门店
  youHai_syncBatchStore() {
    return super.post('youhai/syncBatchStore', ...arguments);
  }
  youHai_reOpenAccount() {
    return super.post('youhai/reOpenAccount', ...arguments);
  }
  youHai_queryYHAccount() {
    return super.post('youhai/queryYHAccount', ...arguments);
  }
  youHai_existYHAccount() {
    return super.post('youhai/existYHAccount', ...arguments);
  }
  youHai_existCangJieccount() {
    return super.post('youhai/existCangJieccount', ...arguments);
  }
}
